import styled from 'styled-components'

const PostDate = styled.div`
  color: var(--text-primary);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.25em;
`

export default PostDate
